// extracted by mini-css-extract-plugin
export default {"container":"style_container__7e29J","logo":"style_logo__XGa38","filePreviewSection":"style_filePreviewSection__Ahsww"};